// https://vuex.vuejs.org/en/actions.html

import NewApiService from "@/utils/new.api.service";

export default {
  get(context, params) {
    context.commit("set_loading");
    return new Promise(resolve => {
      NewApiService.get("prescriptions/" + params.id + "/irons")
        .then(({ data }) => {
          context.commit("unset_loading");
          resolve(data.irons);
        })
        .catch(({ response }) => {
          context.commit("set_error", response.data.errors);
        });
    });
  },

  add(context, params) {
    context.commit("set_loading");
    return new Promise((resolve, reject) => {
      NewApiService.post("prescriptions/" + params.id + "/irons", params.model)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response)
        })
        .finally(() => {
          context.commit("unset_loading");
        })
    });
  },
  addSet(context, params) {
    context.commit("set_loading");
    return new Promise((resolve, reject) => {
      NewApiService.post("prescriptions/" + params.id + "/irons/set", params.model)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response)
        })
        .finally(() => {
          context.commit("unset_loading");
        })
    });
  },
  update(context, params) {
    context.commit("set_loading");
    return new Promise((resolve, reject) => {
      NewApiService.put(
        "prescriptions/" + params.prescriptionId + "/irons/" + params.id,
        params.model
      )
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response)
        })
        .finally(() => {
          context.commit("unset_loading");
        })
    });
  },

  delete(context, params) {
    context.commit("set_loading");
    return new Promise(resolve => {
      NewApiService.delete(
        "prescriptions/" + params.prescriptionId + "/irons/" + params.id
      )
        .then(({ data }) => {
          context.commit("unset_loading");
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit("set_error", response.data.errors);
        });
    });
  },
  quote(context, params) {
    context.commit("set_loading");
    return new Promise(resolve => {
      NewApiService.put(
        "prescriptions/" +
          params.prescriptionId +
          "/irons/" +
          params.id +
          "/quote",
        params
      )
        .then(({ data }) => {
          context.commit("unset_loading");
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit("set_error", response.data.errors);
        });
    });
  }
};
